<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    data-keyboard="false"
    data-backdrop="static"
    aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered modal-lg"
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <slot />
          <!-- TEL-2437: o player só existe enquanto o modal está aberto. Fechar o
               modal do Bootstrap apenas esconde a janela, e um iframe escondido
               continua tocando o vídeo — era o áudio que seguia depois do ×. -->
          <iframe
            v-if="isOpen"
            width="760"
            height="420"
            :src="videoUrl"
            :title="title"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
        </div>
        <div class="modal-footer justify-content-center">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Modal de vídeo tutorial (YouTube) usado pelas integrações, pelo histórico de
 * cobranças e pelo tutorial do Looker Studio.
 *
 * Quem usa chama `open()` pela ref. O vídeo recomeça do início a cada abertura,
 * porque o player é destruído ao fechar.
 */
export default {
  name: 'TutorialVideoModal',
  props: {
    title: {
      type: String,
      required: true
    },
    // URL de incorporação (youtube.com/embed/<ID>). O link youtu.be ou
    // watch?v= é recusado pelo player dentro de um iframe.
    videoUrl: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  mounted () {
    // `hidden` (e não `hide`) para o iframe sair só depois da animação de
    // fechamento; senão a janela encolhe enquanto ainda está sumindo.
    $(this.$refs.modal).on('hidden.bs.modal', this.onHidden)
  },
  beforeDestroy () {
    $(this.$refs.modal).off('hidden.bs.modal', this.onHidden)
  },
  methods: {
    open () {
      this.isOpen = true
      this.$nextTick(() => {
        $(this.$refs.modal).modal('show')
      })
    },
    onHidden () {
      this.isOpen = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/TutorialVideoModal.vue